import { createSelector } from "@ngrx/store";
import { selectMemberModuleState } from "../reducers";

export const distributionMappingSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.distributionMapping
);
